const DiscoutTag = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3780_1982)">
      <path
        d="M10.3919 0.79258C9.4882 -0.264188 7.85414 -0.264199 6.95021 0.79258L6.56487 1.24303C6.38077 1.45844 6.09125 1.55247 5.81556 1.4865L5.23911 1.34854C3.88663 1.0249 2.56475 1.98532 2.45473 3.37155L2.40773 3.96247C2.38525 4.24503 2.20649 4.4912 1.94462 4.59986L1.39711 4.82711C0.112814 5.3602 -0.39213 6.9142 0.33359 8.10038L0.643007 8.60605C0.790989 8.84782 0.790989 9.1521 0.643007 9.39394L0.33359 9.89953C-0.39213 11.0858 0.112814 12.6397 1.39711 13.1729L1.94462 13.4001C2.20649 13.5088 2.38525 13.7549 2.40773 14.0375L2.45473 14.6284C2.56475 16.0146 3.88663 16.9751 5.23911 16.6514L5.81556 16.5135C6.09125 16.4475 6.38077 16.5415 6.56487 16.7569L6.95021 17.2074C7.85414 18.2642 9.4882 18.2642 10.3919 17.2074L10.7773 16.7569C10.9616 16.5415 11.2509 16.4475 11.5266 16.5135L12.103 16.6514C13.4555 16.9751 14.7774 16.0146 14.8876 14.6284L14.9344 14.0375C14.9569 13.7549 15.1358 13.5088 15.3975 13.4001L15.945 13.1729C17.2293 12.6397 17.7343 11.0858 17.0086 9.89953L16.6991 9.39394C16.5514 9.1521 16.5514 8.84782 16.6993 8.60605L17.0086 8.10038C17.7343 6.9142 17.2293 5.3602 15.945 4.82711L15.3975 4.59986C15.1358 4.4912 14.9569 4.24503 14.9344 3.96247L14.8876 3.37155C14.7774 1.98532 13.4555 1.0249 12.103 1.34854L11.5266 1.4865C11.2509 1.55247 10.9616 1.45844 10.7773 1.24303L10.3919 0.79258Z"
        fill="#FFCD4E"
      />
      <path
        d="M7.83818 6.89466C8.20664 6.52619 8.20664 5.92876 7.83818 5.56029C7.46963 5.19182 6.87226 5.19182 6.50377 5.56029L5.56023 6.50384C5.19176 6.87232 5.19176 7.46976 5.56023 7.83822C5.92871 8.20667 6.52613 8.20667 6.89461 7.83822L7.83818 6.89466Z"
        fill="#2B2B2B"
      />
      <path
        d="M12.5559 6.89467C12.9244 6.52619 12.9244 5.92876 12.5559 5.56029C12.1874 5.19182 11.59 5.19182 11.2215 5.56029L5.56023 11.2216C5.19176 11.59 5.19176 12.1875 5.56023 12.5559C5.92871 12.9244 6.52613 12.9244 6.89461 12.5559L12.5559 6.89467Z"
        fill="#2B2B2B"
      />
      <path
        d="M12.5559 11.6124C12.9244 11.2439 12.9244 10.6465 12.5559 10.278C12.1874 9.90958 11.59 9.90958 11.2215 10.278L10.278 11.2216C9.90945 11.59 9.90945 12.1875 10.278 12.5559C10.6465 12.9244 11.2438 12.9244 11.6124 12.5559L12.5559 11.6124Z"
        fill="#2B2B2B"
      />
    </g>
    <defs>
      <clipPath id="clip0_3780_1982">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default DiscoutTag
